<div class="hud-panel">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0 fw-semibold">HUD</h5>
    <button kendoButton class="cyflare-btn-secondary" [svgIcon]="arrowRotateCwIcon" (click)="refreshHud()">
      Refresh HUD
    </button>
  </div>

  <div class="row g-3">
    <div class="col-lg-3 col-md-6 col-sm-12">
      <div class="hud-card-trigger h-100" role="button" tabindex="0" (click)="showOpenThreatsDialog.set(true)"
        (keydown.enter)="showOpenThreatsDialog.set(true)">
        <app-metric-card title="Open Threats"
          tooltip="Threats currently open and unresolved across observed EDR agents." [currentValue]="threats().value"
          [isLoading]="threatsLoading()" [hideComparison]="true" [hidePrevious]="true" [showLeftBorder]="true"
          leftBorderColor="var(--color-info)">
          <ng-template #loading>
            <kendo-skeleton shape="text" animation="wave" width="100px" height="44px"></kendo-skeleton>
          </ng-template>
        </app-metric-card>
      </div>
      <app-edr-grid-dialog [visible]="showOpenThreatsDialog()" [url]="openThreatsUrl()" title="Open Threats"
        [columns]="openThreatsColumns" reportKey="edr-open-threats-report"
        [organizationId]="organizationId()" [dateRange]="dateRange()"
        (visibleChange)="showOpenThreatsDialog.set($event)"></app-edr-grid-dialog>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <div class="hud-card-trigger h-100" role="button" tabindex="0" (click)="showThreatRebootDialog.set(true)"
        (keydown.enter)="showThreatRebootDialog.set(true)">
        <app-metric-card title="Reboot Required"
          tooltip="Endpoints that require a reboot to fully remediate a detected threat."
          [currentValue]="threatReboot().value" [isLoading]="threatRebootLoading()" [hideComparison]="true"
          [hidePrevious]="true" [showLeftBorder]="true" leftBorderColor="var(--color-info)">
          <ng-template #loading>
            <kendo-skeleton shape="text" animation="wave" width="100px" height="44px"></kendo-skeleton>
          </ng-template>
        </app-metric-card>
      </div>
      <app-edr-grid-dialog [visible]="showThreatRebootDialog()" [url]="threatRebootUrl()" title="Endpoint Reboot Required"
        [columns]="threatRebootColumns" reportKey="edr-threat-reboot-report"
        [organizationId]="organizationId()" [dateRange]="dateRange()"
        (visibleChange)="showThreatRebootDialog.set($event)"></app-edr-grid-dialog>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <div class="hud-card-trigger h-100" role="button" tabindex="0" (click)="showOutdatedAgentsDialog.set(true)"
        (keydown.enter)="showOutdatedAgentsDialog.set(true)">
        <app-metric-card title="Outdated Agents"
          tooltip="EDR agents running a version that is behind the current release."
          [currentValue]="outdatedAgents().value" [isLoading]="outdatedAgentsLoading()" [hideComparison]="true"
          [hidePrevious]="true" [showLeftBorder]="true" leftBorderColor="var(--color-info)">
          <ng-template #loading>
            <kendo-skeleton shape="text" animation="wave" width="100px" height="44px"></kendo-skeleton>
          </ng-template>
        </app-metric-card>
      </div>
      <app-edr-grid-dialog [visible]="showOutdatedAgentsDialog()" [url]="outdatedAgentsUrl()" title="Outdated Agents"
        [columns]="outdatedAgentsColumns" reportKey="edr-outdated-agents-report"
        [organizationId]="organizationId()" [dateRange]="dateRange()"
        (visibleChange)="showOutdatedAgentsDialog.set($event)"></app-edr-grid-dialog>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12">
      <div class="hud-card-trigger h-100" role="button" tabindex="0" (click)="showCoverageDialog.set(true)"
        (keydown.enter)="showCoverageDialog.set(true)">
        <app-metric-card title="Agents Deployed" tooltip="Observed EDR agents as a percentage of purchased licenses."
          [currentValue]="coveragePercentageDisplay()" [isLoading]="coverageLoading()"
          [hideComparison]="true" [hidePrevious]="false" [showLeftBorder]="true" leftBorderColor="var(--color-info)">
          <ng-template #loading>
            <kendo-skeleton shape="text" animation="wave" width="100px" height="44px"></kendo-skeleton>
            <kendo-skeleton shape="text" animation="wave" width="140px" height="16px" class="mt-2"></kendo-skeleton>
          </ng-template>
          <ng-template #subtext>
            <div class="metric-subtext">
              <div class="d-flex gap-1">
                <span class="text-muted">Observed:</span>
                <span class="fw-semibold">{{ coverageObserved() ?? '—' }}</span>
              </div>
              <div class="d-flex gap-1">
                <span class="text-muted">Purchased:</span>
                <span class="fw-semibold">{{ coveragePurchasedDisplay() }}</span>
              </div>
            </div>
          </ng-template>
        </app-metric-card>
      </div>
      <app-edr-grid-dialog [visible]="showCoverageDialog()" [url]="coverageUrl()" title="Agents Deployed"
        [columns]="coverageColumns" reportKey="edr-coverage-report"
        [organizationId]="organizationId()" [dateRange]="dateRange()"
        (visibleChange)="showCoverageDialog.set($event)"></app-edr-grid-dialog>
    </div>
  </div>
</div>
